import { p } from './core.js'

// Categoria — Maleiros (módulos avulsos pra cima de roupeiros)
// Caixote raso (~30 cm de altura) que apoia em cima de um roupeiro, com
// uma porta de giro por coluna e interior aberto único (sem divisórias).
//
// Entrada n_portas: 1 a 4 (default 2 via DEFAULT_DIMS do CalculadoraCusto).
// Largura efetiva da porta = C / n_portas.

export const MALEIROS = {

  'Maleiro': {
    entradas: ['C', 'P', 'A', 'n_portas'],
    pecas: [
      p('Lateral',        '15', v => v.P * v.A, 2),
      p('Tampo',          '15', v => v.C * v.P, 1),
      p('Base',           '15', v => v.C * v.P, 1, 'branco'),
      // Portas: 1 por coluna, largura C / n_portas
      p('Porta de giro',  '15',
        v => (v.C / Math.max(1, v.n_portas || 1)) * v.A,
        v => Math.max(1, v.n_portas || 1)),
      p('Fundo do móvel', '6',  v => v.C * v.A, 1),
    ],
    ferragens: v => ({
      dobradica: 2 * Math.max(1, v.n_portas || 1),
      corredica: 0,
      pistao:    0,
      rodinha:   0,
      cabide:    0,
    }),
  },
}
